export const partnersSection = {
  title: ['Партнёры', 'форума'],
  description: 'Компании, которые поддерживают развитие ИИ и деловой среды вместе с нами.',
  generalLabel: 'Генеральный партнёр',
  generalPartner: {
    name: 'Ваша компания',
    logoSrc: '/images/partner-logo-general.png',
    logoText: 'Ваша компания'
  },
  partners: [
    {
      name: 'Yula Studio',
      logoSrc: '/images/partner-logo-yula-studio.png',
      logoText: 'Yula Studio',
      logoHeight: '105px',
      href: 'https://vk.com/klub_pro_n'
    },
    { name: 'GIGMA AI', logoSrc: '/images/partner-logo-gigma-ai.png', href: 'https://vk.com/gigma_ai' },
    { name: 'Avacada', logoSrc: '/images/partner-logo-avacada.png', href: 'https://avacada.ru/' },
    { name: 'Pride', logoSrc: '/images/partner-logo-pride.png', href: 'https://prideforum.ru/businessclub' },
    { name: 'ITConstruct', logoSrc: '/images/partner-logo-itconstruct.png', href: 'https://itconstruct.ru/' },
    { name: 'Laika Info', logoSrc: '/images/partner-logo-laikainfo.svg', href: 'https://laikainfo.com/' },
    { name: 'Lexis Voice', logoSrc: '/images/partner-logo-lexis-voice.png' },
    { name: 'Деловой квартал', logoSrc: '/images/partner-logo-delovoy-kvartal.png', invert: true },
    {
      name: 'IMPACTUM',
      logoSrc: '/images/partner-logo-impactum.png',
      href: 'https://impactum.community/novosibirsk',
      invert: true
    },
    { name: 'Ваша компания', logoSrc: '/images/partner-logo-placeholder.png', logoText: 'Ваша компания' },
    { name: 'Ваша компания', logoSrc: '/images/partner-logo-placeholder.png', logoText: 'Ваша компания' }
  ],
  showAll: { label: 'Показать все', href: '#partners' },
  cta: {
    title: 'Хотите представить бренд на форуме?',
    text: 'Партнёрские интеграции, зона бренда, коммуникации с аудиторией.',
    action: {
      label: 'Стать партнёром',
      href: 'https://max.ru/u/f9LHodD0cOJ1otgVx9KGa4maaCIVqQH5TX7X3JwN8a8incQQs69OylZpCCU',
      target: '_blank',
      rel: 'noreferrer'
    }
  }
};
